import React, { PureComponent } from 'react';

interface IEllipsis {
    line: number;
    ellipsis: string;
    timeout: boolean;
    duration: number;
}

export default class Ellipsis extends PureComponent<IEllipsis, any> {
    public static defaultProps = {
        line: 2,
        ellipsis: '...',
        timeout: false,
        duration: 500
    };

    public text: string = '';
    public h = null;
    public ellip: any = React.createRef();
    public getHeight: any = React.createRef();

    constructor(props: IEllipsis) {
        super(props);
        this.text = '';
        this.setLineClamp = this.setLineClamp.bind(this);
        this.setLineNormal = this.setLineNormal.bind(this);
        this.clipText = this.clipText.bind(this);
        this.init = this.init.bind(this);
    }

    public componentDidMount() {
        this.init();
    }

    public componentDidUpdate() {
        this.init();
    }

    public init() {
        if ((document.documentElement.style.webkitLineClamp !== undefined) && ('webkitLineClamp' in document.documentElement.style)) {
             this.setLineClamp();
             this.removeTpl();
             return;
        }

        if (this.props.timeout) {
            setTimeout(() => {
                this.setLineNormal();
                this.clipText();
            }, this.props.duration);
        } else {
            this.setLineNormal();
            this.clipText();
        }
    }

    public removeTpl() {
        try {
            this.ellip.current.removeChild(this.getHeight);
        }
        catch (err) {}
    }

    public setLineNormal() {
        Object.assign(this.ellip.current.style, {
            // 'word-break': 'break-all',
            'white-space': 'normal'
        });
    }

    public setLineClamp() {
        Object.assign(this.ellip.current.style, {
            'overflow': 'hidden',
            'display': '-webkit-box',
            'webkitBoxOrient': 'vertical',
            // 'word-break': 'break-all',
            'white-space': 'normal',
            'webkitLineClamp': this.props.line
        });
    }

    public clipText() {
        const {line, ellipsis} = this.props;
        const ellip = this.ellip.current;

        if (!this.h) {
            const getHeight = this.getHeight.current;
            this.h = getHeight.offsetHeight;
            this.removeTpl();
        }

        const getCountHeight = () => {
            return parseFloat(ellip.offsetHeight) + 5; // 5 is deviation value
        };

        let init = true;

        if (!this.text) {
            this.text = ellip.textContent;
        }
        else {
            ellip.innerHTML = this.text;
        }

        let text = this.text;
        const clip = () => {
            let len = 0;
            while (Math.floor(getCountHeight() / (this.h || 1)) > line && len < 1000) {
                len += 5;
                text = text.slice(0, -5);
                ellip.innerHTML = text;

                if (!init) {
                    ellip.innerHTML += ellipsis;
                }
            }

            return len;
        };

        if (0 < clip()) {
            ellip.innerHTML += ellipsis;
            init = false;
            clip();
        }
    }

    public render() {
        const {children} = this.props;

        return (
                <span ref={this.ellip}>
                    {children}
                    <span className="hiddenSpan" ref={this.getHeight} style={{visibility: 'hidden'}}>0</span>
                </span>
        );
    }
}
